import * as THREE from 'three';

/** A rotation-only support turns at the socket by half the arm's rotation, carrying the middle of the shoulder bridge. */
export function shoulderSkinBone(arm: THREE.Object3D, side: string, thickness = 1) {
  const bone = new THREE.Bone();
  const direction = new THREE.Vector3();
  bone.name = `shoulder_skin.${side}`;
  bone.userData.nimblezSkinSupport = true;
  // Moved inward, or lifted further, it pushes the cap out into a pointed wing when the arm rises.
  bone.position.copy(arm.position);
  bone.updateMatrix = () => {
    bone.quaternion.identity().slerp(arm.quaternion, .5);
    direction.set(0, -1, 0).applyQuaternion(arm.quaternion);
    // Between T and Y it rises a little, so the top of the shoulder nearest the neck does not sink into the chest.
    bone.position.copy(arm.position);
    bone.position.y += .02 * thickness * THREE.MathUtils.smoothstep(direction.y, 0, .5);
    THREE.Bone.prototype.updateMatrix.call(bone);
  };
  arm.parent!.add(bone);
  return bone;
}
